module.exports = __webpack_public_path__ + "static/media/rect.0d79d5dc.svg";